import { useState, useEffect } from "react";

const DESKTOP_MQ = "(min-width: 769px)";

/**
 * PC 断点（≥769px）。首屏 width 未就绪时 isReady=false，避免 SSR/CSR 闪侧栏。
 */
export default function useIsDesktop() {
  const [isDesktop, setIsDesktop] = useState(false);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) {
      setIsReady(true);
      return undefined;
    }
    const mql = window.matchMedia(DESKTOP_MQ);
    const update = () => {
      setIsDesktop(!!mql.matches);
      setIsReady(true);
    };
    update();
    if (mql.addEventListener) mql.addEventListener("change", update);
    else mql.addListener(update);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener("change", update);
      else mql.removeListener(update);
    };
  }, []);

  return { isDesktop, isReady };
}
